import React from 'react';
import ComparisonPage from './ComparisonPage';

export default function VsIClassPro() {
    return <ComparisonPage slug="iclasspro" />;
}
